// 카멜 케이스를 언더바 케이스로 변환
export const camelToSnakeCase = (input: any): any => {
  if (Array.isArray(input)) {
    return input.map((item) => camelToSnakeCase(item)); // 배열일 경우 각 요소를 변환
  } else if (input !== null && typeof input === 'object') {
    const converted: Record<string, any> = {};
    for (const key in input) {
      if (Object.prototype.hasOwnProperty.call(input, key)) {
        const value = input[key];
        const snakeCaseKey = key.replace(/[A-Z]/g, (match: string) => '_' + match.toLowerCase());
        converted[snakeCaseKey] = camelToSnakeCase(value); // 내부 객체도 재귀적으로 변환
      }
    }
    return converted;
  }
  return input; // 기본값(객체나 배열이 아닐 경우)은 그대로 반환
};

// 언더바 케이스를 카멜 케이스로 변환
// export const snakeToCamelCase = (input: string): string => {
//   return input.replace(/_(?<char>[a-z])/g, (_, char) => char.toUpperCase());
// };
// 테스트

export const snakeToCamelCase = (input: any): Record<string, string | number> => {
  const converted: Record<string, string> = {};
  for (const key in input) {
    if (Object.prototype.hasOwnProperty.call(input, key)) {
      const value = input[key];
      converted[key.replace(/_(?<char>[a-z])/g, (_, char) => char.toUpperCase())] = value;
    }
  }
  return converted;
};

// 카멜 케이스를 하이픈 케이스로 변환 (HTTP 헤더용)
export const camelToKebabCase = (input: any): any => {
  if (Array.isArray(input)) {
    return input.map((item) => camelToKebabCase(item)); // 배열일 경우 각 요소를 변환
  } else if (input !== null && typeof input === 'object') {
    const converted: Record<string, any> = {};
    for (const key in input) {
      if (Object.prototype.hasOwnProperty.call(input, key)) {
        const value = input[key];
        const kebabCaseKey = key.replace(/[A-Z]/g, (match: string) => '-' + match.toLowerCase());
        converted[kebabCaseKey] = camelToKebabCase(value); // 내부 객체도 재귀적으로 변환
      }
    }
    return converted;
  }
  return input; // 기본값(객체나 배열이 아닐 경우)은 그대로 반환
};
